module.exports = __webpack_public_path__ + "img/frame (104).14e15c8c.jpg";